import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../commonComponents/translate';
import CreditCardItem from './CreditCardItem';
import StripeCardProp from '../../../../propTypes/StripeCardProp';
import ManualPayment from './ManualPayment';
import CreditCardAdd from './CreditCardAdd';

function CreditCardSelector(props) {
  const handleSelectCard = cardId => {
    if (props.isModeSelection) {
      props.onSelectCard(cardId);
      if (props.isManualInvoiceSelected) {
        props.onManualInvoiceSelection(false);
      }
    }
  };

  const handleAddCard = data => {
    if (props.onAddCard) {
      props.onAddCard(data);
      if (props.isManualInvoiceSelected) {
        props.onManualInvoiceSelection(false);
      }
    }
  };

  const handleRemoveCard = cardId => {
    if (props.onRemoveCard) {
      props.onRemoveCard(cardId);
    }
  };

  const {
    t,
    cards,
    displayManualInvoice,
    onManualInvoiceSelection,
    isManualInvoiceSelected,
    isModeSelection,
    hasError,
  } = props;

  return (
    <div className="m-form__section">
      <div className="m-form__heading">
        {hasError ? (
          <h6 className="m-form__heading-title m--font-danger">
            {`${t('choose_payment_method')}*`}
          </h6>
        ) : (
          <h6 className="m-form__heading-title">
            {t('choose_payment_method')}
          </h6>
        )}
      </div>
      <div className="form-group m-form__group">
        <div className="row">
          {cards.map(card => (
            <div className="col-md-6 m--margin-bottom-30" key={card.id}>
              <CreditCardItem
                id={card.id}
                last4={card.last4}
                exp_month={card.exp_month}
                exp_year={card.exp_year}
                brand={card.brand}
                isSelected={card.isDefault && !isManualInvoiceSelected}
                displayRemove={!card.isDefault}
                onSelect={handleSelectCard}
                onRemove={handleRemoveCard}
                readOnly={isModeSelection}
              />
            </div>
          ))}
          {displayManualInvoice && (
            <div className="col-md-6 m--margin-bottom-30">
              <ManualPayment
                isManualInvoiceSelected={isManualInvoiceSelected}
                onManualInvoiceSelection={onManualInvoiceSelection}
              />
            </div>
          )}
          {isModeSelection ? <CreditCardAdd onAdd={handleAddCard} /> : <div />}
        </div>
        <div className="m-form__help" />
      </div>
    </div>
  );
}

CreditCardSelector.propTypes = {
  t: PropTypes.func.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(StripeCardProp.propType)),
  onSelectCard: PropTypes.func,
  isManualInvoiceSelected: PropTypes.bool,
  displayManualInvoice: PropTypes.bool,
  onManualInvoiceSelection: PropTypes.func,
  isModeSelection: PropTypes.bool,
  onAddCard: PropTypes.func,
  onRemoveCard: PropTypes.func,
  hasError: PropTypes.bool,
};

CreditCardSelector.defaultProps = {
  cards: [],
  onSelectCard: null,
  onAddCard: null,
  onRemoveCard: null,
  isManualInvoiceSelected: false,
  displayManualInvoice: false,
  onManualInvoiceSelection: () => null,
  isModeSelection: false,
  hasError: false,
};

export default translate(CreditCardSelector);
